// Utilities to analyze schedule quality

export function buildTeammateMatrix(players, tournamentMatrix) {
  const idx = new Map(players.map((p, i) => [p, i]));
  const n = players.length;
  const M = Array.from({ length: n }, () => Array(n).fill(0));

  tournamentMatrix.forEach(round => {
    const byTeam = new Map();
    round?.assignments?.forEach(a => {
      if (!byTeam.has(a.team)) byTeam.set(a.team, []);
      byTeam.get(a.team).push(a.playerName);
    });
    for (const lst of byTeam.values()) {
      for (let i = 0; i < lst.length; i++) {
        for (let j = i + 1; j < lst.length; j++) {
          const pi = idx.get(lst[i]);
          const pj = idx.get(lst[j]);
          if (pi != null && pj != null) {
            M[pi][pj]++; M[pj][pi]++;
          }
        }
      }
    }
  });
  return { matrix: M, index: idx };
}

export function summarizeTeammates(players, M) {
  const n = players.length;
  const perPlayer = players.map((p, i) => {
    let unique = 0, maxRepeat = 0, totalCoPlays = 0;
    for (let j = 0; j < n; j++) if (i !== j) {
      if (M[i][j] > 0) unique++;
      if (M[i][j] > maxRepeat) maxRepeat = M[i][j];
      totalCoPlays += M[i][j];
    }
    return { player: p, uniqueTeammates: unique, maxWithSameTeammate: maxRepeat, totalCoPlays };
  });
  return {
    perPlayer,
    minUniqueTeammates: Math.min(...perPlayer.map(x => x.uniqueTeammates)),
    maxRepeatWithSameTeammate: Math.max(...perPlayer.map(x => x.maxWithSameTeammate))
  };
}

export function buildFieldUsage(players, tournamentMatrix, getTeamField) {
  const usage = new Map(players.map(p => [p, new Map()]));
  tournamentMatrix.forEach((round, rIdx) => {
    const byTeam = new Map();
    round?.assignments?.forEach(a => {
      if (!byTeam.has(a.team)) byTeam.set(a.team, []);
      byTeam.get(a.team).push(a.playerName);
    });
    for (const [team, lst] of byTeam.entries()) {
      const field = getTeamField ? getTeamField(rIdx, team) : undefined;
      if (field == null) continue;
      for (const p of lst) {
        const m = usage.get(p);
        m.set(field, (m.get(field) || 0) + 1);
      }
    }
  });
  return usage;
}

export function summarizeFieldUsage(usageMap) {
  const perPlayer = [];
  for (const [player, m] of usageMap.entries()) {
    const counts = Array.from(m.values());
    const total = counts.reduce((a, b) => a + b, 0);
    const max = counts.length ? Math.max(...counts) : 0;
    const min = counts.length ? Math.min(...counts) : 0;
    perPlayer.push({ player, total, max, min, spread: max - min });
  }
  return {
    perPlayer,
    maxSpread: Math.max(0, ...perPlayer.map(x => x.spread))
  };
}
